import React, { useRef, useState } from "react";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form"
import { Upload, Icon, message, Button as AntdBtn } from "antd";
import "antd/dist/antd.css";
import { UploadOutlined } from "@ant-design/icons";

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/unittype/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.unittype.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_UNIT_TYPE_ASYNC]: { done: this._handleSaveUnitTypeAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.UPLOAD_PHOTO_ASYNC]: { done: null, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createUnitType();
    }

    render() {
        const { unitType } = this.props.localState;
        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!unitType || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    unitType={unitType}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSaveUnitType}
                                    onUpload={this.props.uploadPhotoAsync}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_UNIT_TYPE_ASYNC) || this.isActionExecuting(ActionTypes.UPLOAD_PHOTO_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSaveUnitType = (data) => {
        const { unitType } = this.props.localState;
        data = { ...unitType, ...data };
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.saveUnitTypeAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveUnitTypeAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { unitType } = props;
    const { id, imageUrl, category, title, description, duration, enabled, translation, pinyin, version, director } = unitType;
    const { register, handleSubmit, errors } = useForm();
    const [loading, setLoading] = useState(false);
    const submitRef = useRef();

    const uploadButton = (
        <AntdBtn>
            {loading ? <Icon type="loading" /> : <UploadOutlined />}{props.t("upload")}
        </AntdBtn>
    );

    const uploadProps = {
        name: "fileData",
        showUploadList: false, // set to only upload one file        
        customRequest: info => {
            props.onUpload(info.file, id);
        },
        onChange: info => {
            if (info.file.status === "uploading") {
                setLoading(true);
            }
        },
        listType: "picture-card",
        className: "avatar-uploader",
        beforeUpload: file => {
            //const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
            const isJpgOrPng = file.type === "image/png";
            if (!isJpgOrPng) {
                message.error(props.t("uploadImageFormatLimited"));
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                message.error(props.t("uploadImageSizeLimited", { fileSize: 2 }));
                return false;
            }
            return isJpgOrPng && isLt2M;
        }
    };

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("unittype")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("id")}</label>
                                    <input name="id" type="text" className="form-control-alternative form-control" defaultValue={id} disabled
                                        ref={register}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("photo")}</label>
                                    <Upload {...uploadProps}>
                                        {!imageUrl ? uploadButton : <img src={imageUrl + "?" + Math.random()} alt="..." style={{ width: "100%" }} />}
                                    </Upload>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("duration")}</label>
                                    <input name="duration" type="text" className="form-control-alternative form-control" defaultValue={duration}
                                        ref={register}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("category")}</label>
                                    <input name="category" type="text" className="form-control-alternative form-control" defaultValue={category}
                                        ref={register({ required: true })}
                                    />
                                    {errors.category && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label" htmlFor="title">{props.t("title")}</label>
                                    <input name="title" type="text" className="form-control-alternative form-control" defaultValue={title}
                                        ref={register({ required: true })}
                                    />
                                    {errors.title && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label" htmlFor="description">{props.t("description")}</label>
                                    <textarea name="description" rows="4" className="form-control-alternative form-control" defaultValue={description}
                                        ref={register} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label" htmlFor="enabled">{props.t("enabled")}</label>
                                    <input name="enabled" type="checkbox" className="form-control-alternative form-control" defaultChecked={enabled}
                                        ref={register}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label" htmlFor="translation">{props.t("translation")}</label>
                                    <input name="translation" type="checkbox" className="form-control-alternative form-control" defaultChecked={translation}
                                        ref={register}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label" htmlFor="pinyin">{props.t("pinyin")}</label>
                                    <input name="pinyin" type="checkbox" className="form-control-alternative form-control" defaultChecked={pinyin}
                                        ref={register}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label" htmlFor="version">{props.t("version")}</label>
                                    <input name="version" type="text" className="form-control-alternative form-control" defaultValue={version}
                                        ref={register}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label" htmlFor="director">{props.t("director")}</label>
                                    <input name="director" type="text" className="form-control-alternative form-control" defaultValue={director}
                                        ref={register}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveUnitTypeAsync: vo => dispatch(Actions.saveUnitTypeAsync(vo)),
        createUnitType: () => dispatch(Actions.createUnitType()),
        uploadPhotoAsync: (file, id) => dispatch(Actions.uploadPhotoAsync(file, id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));